import template from './equifaxDialog.template.html';

export default {
  bindings: {
    onFinished: '&',
    idTicket: '<',
    latestScore: '<',
    isEquifaxEnabled: '<',
    contact: '<',
    loanAmount: '<'
  },
  controller: class controller {
    constructor(
      $rootScope,
      $filter,
      $mdDialog,
      eventService,
      equifaxService,
      ContactCreditScore,
      ContactCreditScoreType,
      Contact,
      PersonalTitle,
      ContactGender,
      uiService,
      notesService,
      EQUIFAX
    ) {
      'ngInject';

      const $ctrl = this;

      $ctrl.initialize = () => {
        $mdDialog
          .show({
            targetEvent: '',
            locals: {
              isEquifaxEnabled: $ctrl.isEquifaxEnabled,
              contact: $ctrl.contact,
              loanAmount: $ctrl.loanAmount,
              idTicket: $ctrl.idTicket
            },
            template,
            controllerAs: '$ctrl',
            multiple: true,
            controller(isEquifaxEnabled, contact, loanAmount, idTicket) {
              const ctrl = this;
              ctrl.latestScore = $ctrl.latestScore;
              ctrl.latestEnquiryId = $ctrl.latestScore?.enquiryId || '';
              ctrl.latestEnquiryTime = $ctrl.latestScore?.timeStamp || 0;
              ctrl.latestEnquiryTimeDiff = moment().diff(
                moment.utc(ctrl.latestEnquiryTime, 'X'),
                'days'
              );

              ctrl.isReady = true;
              ctrl.creditScore = null;
              ctrl.isEquifaxEnabled = isEquifaxEnabled;
              ctrl.loanAmount = loanAmount || 1;
              ctrl.CurrentCurrency = $rootScope.CurrentCurrency;
              ctrl.accountType = EQUIFAX.EQUIFAX_ACCOUNT_TYPES[7].id;
              ctrl.clientRelationship = EQUIFAX.EQUIFAX_ACCOUNT_RELATIONSHIP[0].id;
              ctrl.contact = Contact.build(JSON.parse(JSON.stringify(contact)));
              ctrl.isErrorResponse = false;
              ctrl.errorMessages = [];
              ctrl.equifaxErrorMessages = [];
              ctrl.accountRelationshipAvailable = EQUIFAX.EQUIFAX_ACCOUNT_RELATIONSHIP;
              ctrl.accountTypeAvailable = EQUIFAX.EQUIFAX_ACCOUNT_TYPES;

              ctrl.streetNumberValidate = (address, isPrevious) => {
                if (isPrevious && !address.street) {
                  return true;
                }
                if (address.streetNumber) {
                  return (
                    Number.isInteger(parseInt(address.streetNumber.charAt(0), 10)) &&
                    address.streetNumber.length <= 8
                  );
                }
                return false;
              };

              if (!ctrl.isEquifaxEnabled) {
                ctrl.errorMessages.push(
                  'Deal Owner does not have Equifax enabled. Equifax can be enabled via Settings -> Integrations -> 3rd party applications.'
                );
              }
              if (
                !ctrl.contact?.person?.information?.firstName ||
                !ctrl.contact?.person?.information?.familyName ||
                ctrl.contact?.person?.information?.title.name === PersonalTitle.none.name ||
                ctrl.contact?.person?.information?.gender.name === ContactGender.none.name
              ) {
                ctrl.errorMessages.push(
                  "Client's details are not filled in. Client's title (eg. Mr, Mrs), first name, surname, gender and date of birth are required fields."
                );
              }
              if (
                !ctrl.contact?.person?.contact?.address?.street ||
                !ctrl.contact?.person?.contact?.address?.suburb ||
                !ctrl.contact?.person?.contact?.address?.state ||
                !ctrl.contact?.person?.contact?.address?.postCode
              ) {
                ctrl.errorMessages.push(
                  "Client's address are not filled in. Client's address details - street number, street name, suburb, state, country and postal code are required fields."
                );
              }
              if (!ctrl.streetNumberValidate(ctrl.contact?.person?.contact?.address)) {
                ctrl.errorMessages.push(
                  'Client\'s address street number is not valid. Street number must start with numeric value (eg. "56 Lot"), be at least one character, and not more than eight characters.'
                );
              }
              if (
                !ctrl.streetNumberValidate(ctrl.contact?.person?.contact?.previousAddress, true)
              ) {
                ctrl.errorMessages.push(
                  'Client\'s previous address street number is not valid. Street number must start with numeric value (eg. "56 Lot"), be at least one character, and not more than eight characters.'
                );
              }
              if (ctrl.errorMessages?.length) {
                ctrl.errorMessages.unshift('Equifax errors:');
              }

              ctrl.hasErrors = () => ctrl.errorMessages?.length > 0;

              ctrl.confirm = () => {
                if (!ctrl.sendEquifax.$valid || ctrl.hasErrors()) {
                  return;
                }
                ctrl.isReady = false;
                equifaxService
                  .getScoreAndReport({
                    idContact: ctrl.contact.id,
                    loanAmount: ctrl.loanAmount,
                    accountType: ctrl.accountType,
                    clientRelationship: ctrl.clientRelationship,
                    idTicket
                  })
                  .then((result) => {
                    if (result.status && !_.isEmpty(result?.creditScore)) {
                      ctrl.creditScore = ContactCreditScore.build(result.creditScore);
                      ctrl.creditScore.type = ContactCreditScoreType.equifax;
                      ctrl.creditScore.idAccount = $rootScope.CurrentAccount.id;
                      ctrl.creditScore.idTicket = idTicket;
                      ctrl.isReady = true;
                      uiService.toast({
                        text: {
                          p1: 'PDF Report ',
                          p2: result?.isPdfReport || false ? 'retrieved' : 'not retrieved',
                          p3: result?.isPdfReport || false ? 'as Note' : 'There was an error.'
                        },
                        success: result?.isPdfReport || false,
                        warn: !result?.isPdfReport || false
                      });
                      $mdDialog.hide({
                        idContact: contact.id,
                        creditScore: _.get(contact, 'creditScore.length')
                          ? contact.creditScore.concat(ctrl.creditScore)
                          : [ctrl.creditScore]
                      });
                    } else {
                      ctrl.isErrorResponse = true;
                      if (result?.errors?.length) {
                        const len = result?.errors?.length || 0;
                        for (let e = 0; e < len; e += 1) {
                          const error = result?.errors[e];
                          const message = error?.label
                            ? `${error?.label?.sanitize()} -> ${error?.message || ''}`
                            : error?.message || error || '';
                          ctrl.equifaxErrorMessages.push(message);
                        }
                      } else {
                        ctrl.equifaxErrorMessages.push(result?.errorMessage);
                      }
                      ctrl.isReady = true;
                    }
                  })
                  .catch(() => {
                    ctrl.isReady = true;
                  });
              };

              ctrl.getPreviousReport = () => {
                uiService.toast({
                  text: {
                    p1: 'Downloading previous enquiry',
                    p2: 'Pdf report',
                    p3: 'Please wait...'
                  },
                  success: true
                });
                const contactFullName =
                  $ctrl.contact.person.information.firstName +
                  $ctrl.contact.person.information.familyName;

                equifaxService
                  .getPreviousReport({
                    idTicket: $ctrl.idTicket,
                    idContact: $ctrl.contact.id,
                    contactFullName,
                    enquiryId: ctrl.latestEnquiryId
                  })
                  .then((result) => {
                    if (result.status) {
                      uiService.toast({
                        text: {
                          p1: 'Pdf Report',
                          p2: 'saved ',
                          p3: 'as Note'
                        },
                        success: true
                      });
                      notesService.clearCache();
                    } else {
                      uiService.toast({
                        text: {
                          p1: 'Pdf Report',
                          p2: 'retrieving ',
                          p3: 'failed'
                        },
                        warn: true
                      });
                    }
                  });
              };

              ctrl.cancel = () => {
                $mdDialog.hide();
              };
            }
          })
          .then((result) => {
            $ctrl.onFinished(result);
          });
      };

      $ctrl.$onInit = () => {
        $ctrl.initialize();
      };
    }
  }
};
